import React from "react";
import { Link } from "react-router-dom";
import { parseInlineLinks, InlineSegment } from "../../utils/inlineLinks";
import styles from "./releasesInfoPage.module.scss";

type LinkSegment = Extract<InlineSegment, { type: "link" }>;

function FeatureLink({ segment }: { segment: LinkSegment }) {
    // Release-note links go to site pages (react-router, no full reload). An https URL is
    // supported for completeness: it is a plain anchor that opens in a new tab.
    if (segment.external) {
        return (
            <a className={styles.featureLink} href={segment.href} target="_blank" rel="noopener noreferrer">
                {segment.text}
            </a>
        );
    }
    return (
        <Link className={styles.featureLink} to={segment.href}>
            {segment.text}
        </Link>
    );
}

/**
 * One release-note bullet. Plain strings render as-is; `[visible text](/path)` markup becomes
 * a link whose visible text is part of the sentence (see src/utils/inlineLinks.ts). The href
 * is used exactly as written in the locale JSON - the PT file carries the PT routes - so it is
 * deliberately not run through localizePath (that would send `/blog/<ptSlug>` through a redirect).
 */
function ReleaseFeatureText({ text }: { text: string }) {
    const segments = parseInlineLinks(text);
    return (
        <>
            {segments.map((segment, index) => {
                // Segments come from a static string, so the position is a stable key.
                const key = `${index}-${segment.text}`;
                if (segment.type === "link") return <FeatureLink key={key} segment={segment} />;
                return <React.Fragment key={key}>{segment.text}</React.Fragment>;
            })}
        </>
    );
}

export default ReleaseFeatureText;
